<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} ingreso
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()" autocomplete="off">
          <div class="row">
            <div class="col-lg-12" *ngIf="validatealert">
              <ng-container *ngIf="moneybox != null">
                <ng-container *ngIf="moneybox.status_closed == true || moneybox.is_before">
                  <div class="alert alert-danger alert-dismissible fade show" role="alert">
                    <!-- <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                                  <span aria-hidden="true">×</span>
                                </button> -->
                    Debe corregir el estado de la caja para realizar movimientos de dinero,
                    <a class="bold text-white text-underline" routerLink="/{{branchofficeSlug}}/caja/apertura">Clic para
                      ir a caja.</a>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!check_moneybox">
                <div class="alert alert-danger alert-dismissible fade show" role="alert">
                  Debe aperturar la caja para realizar movimientos de dinero,
                  <a class="bold text-white text-underline" routerLink="/{{branchofficeSlug}}/caja/apertura">Clic para
                    ir a caja.</a>
                </div>
              </ng-container>
            </div>
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-6" *ngIf="boxselected != null">
                  <label>
                    Caja seleccionada
                    <ng-container *ngIf="check_moneybox">
                      ( <span *ngIf="moneybox.status_closed == false" class="badge badge-primary">Estado abierta</span>
                      <span *ngIf="moneybox.status_closed == true" class="badge badge-danger">Estado cerrada</span> )
                    </ng-container>
                    <ng-container *ngIf="!check_moneybox">
                      ( <span class="badge badge-danger">Estado cerrada</span> )
                    </ng-container>

                    <span class="required"></span>
                  </label>
                  <input type="text" disabled value="{{boxselected.description}}" class="form-control">
                  <ng-container *ngIf="check_moneybox">
                    <ng-container *ngIf="moneybox.is_before">
                      <span class="badge badge-warning f-s-11" ng-if="moneybox.is_before">CONTINÚA EN FECHA ANTERIOR :
                        {{moneybox.date_opening}}</span>
                    </ng-container>
                  </ng-container>
                </div>
                <div class="form-group col-lg-6">
                  <label>Descripción ingreso <span class="required"></span></label>
                  <input type="text" id="income_gloss" formControlName="gloss" required class="form-control" autofocus>
                  <div *ngIf="submitted && f['gloss'].errors">
                    <small class="text-danger" *ngIf="f['gloss'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <label>Emisor/procedente (opcional)</label>
                  <div class="row">
                    <div class="col-lg-4 p-r-0">
                      <select class="form-control bg-light" id="positionSelected" [(ngModel)]="positionSelected"
                        [ngModelOptions]="{standalone: true}" ng-change="changePositionSelected()">
                        <option *ngFor="let item of userpositions" [value]="item.id">{{ item.description }}</option>
                      </select>
                    </div>
                    <div class="col-lg-8 p-l-0">
                      <ng-container *ngIf="isPositionSelected">
                        <div class="input-group">
                          <input type="text" class="form-control form-control-sm" disabled
                            value="{{possitionValue.fullname}}">
                          <div class="input-group-append bg-custom b-0 removeClient">
                            <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                              (click)="removePositionSelected()">
                              <i class="fas fa-backspace w-100 f-s-12"></i>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="!isPositionSelected">
                        <ng-container *ngIf="positionSelected == user_client.id">
                          <component-search-client [classSize]="'search-small'"
                            (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                          </component-search-client>
                        </ng-container>
                        <ng-container *ngIf="positionSelected == user_provider.id">
                          <component-search-provider [classSize]="'search-small'"
                            (selectedProviderEvent)="selectedProviderSearch($event)" class="w-100">
                          </component-search-provider>
                        </ng-container>
                        <ng-container *ngIf="positionSelected == user_employee.id">
                          <component-search-employee [classSize]="'search-small'"
                            (selectedEmployeeEvent)="selectedEmployeeSearch($event)" class="w-100">
                          </component-search-employee>
                        </ng-container>
                        <ng-container *ngIf="positionSelected == user_guide.id">
                          <component-search-guides [classSize]="'search-small'"
                            (selectedGuideEvent)="selectedGuideSearch($event)" class="w-100">
                          </component-search-guides>
                        </ng-container>
                        <ng-container *ngIf="positionSelected == user_transport.id">
                          <component-search-transport [classSize]="'search-small'"
                            (selectedTransportEvent)="selectedTransportSearch($event)" class="w-100">
                          </component-search-transport>
                        </ng-container>
                        <ng-container *ngIf="positionSelected == user_agency.id">
                          <component-search-agencies [classSize]="'search-small'"
                            (selectedAgenciesEvent)="selectedAgenciesSearch($event)" class="w-100">
                          </component-search-agencies>
                        </ng-container>
                        <ng-container *ngIf="positionSelected == user_hotel.id">
                          <component-search-hotel [classSize]="'search-small'"
                            (selectedHotelEvent)="selectedHotelSearch($event)" class="w-100">
                          </component-search-hotel>
                        </ng-container>
                        <ng-container *ngIf="positionSelected == user_collaborator.id">
                          <component-search-collaborators [classSize]="'search-small'"
                            (selectedCollaboratorsEvent)="selectedCollaboratorsSearch($event)" class="w-100">
                          </component-search-collaborators>
                        </ng-container>    
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <label>Concepto ingreso<span class="required"></span>
                    <button type="button" data-toggle="modal" data-target="#openExtendsConceptIncome"
                      (click)="ConceptIncomeExtendsComponent.focused()"
                      class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                    </button>
                  </label>
                  <select class="form-control" id="conceptSelected" required formControlName="concept_id">
                    <option value="null">Seleccionar opción</option>
                    <option *ngFor="let item of concepts" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['concept_id'].errors">
                    <small class="text-danger" *ngIf="f['concept_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <div class="form-group col-lg-3">
                  <label>Método de pago <span class="required"></span></label>
                  <select class="form-control" id="paymentSelected" formControlName="paymentmethod_id"
                    (change)="changePaymentMethod()" required>
                    <option *ngFor="let item of paymentmethods" [value]="item.id">{{ item.description }}</option>
                  </select>
                  <div *ngIf="submitted && f['paymentmethod_id'].errors">
                    <small class="text-danger" *ngIf="f['paymentmethod_id'].errors['required']">Campo requerido</small>
                  </div>
                </div>
                <ng-container *ngIf="paymentMethodSelected.associate_bank">
                  <div class="form-group col-lg-3">
                    <label>Cuenta destino
                      <span class="f-s-9" *ngIf="accountbanks.length == 0">( 0 registros )</span>
                      <!-- <button type="button" ng-click="addAccountBank(true)" ng-if="bankaccounts_exists == true"
                        class="btn btn-outline-success btn-extends float-right"><i class="fa fa-plus m-r-5"></i>Nuevo
                      </button> -->
                    </label>
                    <ng-container *ngIf="accountbanks.length == 0">
                      <a type="button" class="btn btn-outline-info"
                        routerLink="/{{branchofficeSlug}}/finanzas/cuentas_bancarias/lista">
                        <i class="fas fa-arrow-right m-r-5"></i>Agregar Cuenta
                      </a>
                    </ng-container>
                    <ng-container *ngIf="accountbanks.length > 0">
                      <select class="form-control" id="bankAccountSelected" (change)="changeBankAccount($event.target)">
                        <option *ngIf="!isEdit" value="null">Seleccionar cuenta</option>
                        <option *ngFor="let item of accountbanks" [value]="item.id">{{ item.concat_description}}
                        </option>
                      </select>
                    </ng-container>
                  </div>
                  <div class="form-group col-lg-3">
                    <label>N° operación</label>
                    <input type="text" class="form-control" formControlName="reference_operation">
                  </div>
                </ng-container>
                <div class="form-group col-lg-3">
                  <label>Monto <span class="required"></span>
                    <!-- <div class="float-right" ng-if="is_edit" style="margin-bottom: -5px">
                      <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" ng-model="change_amount" id="change_amount"
                          ng-change="activeChangeAmount(change_amount)">
                        <label class="custom-control-label p-t-3 f-s-12" for="change_amount">
                          ¿Modificar?
                          <span data-toggle="tooltip" data-placement="right"
                            data-original-title="Para modificar el monto considere el balance de su caja actual (efectivo)"
                            title=""><i class="fas fa-info-circle m-l-5"></i>
                          </span>
                        </label>
                      </div>
                    </div> -->
                  </label>
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <span class="input-group-text">{{toolsService.momeySol()}}</span>
                    </span>
                    <input type="text" class="form-control bold f-s-14" id="income_amount" required
                      formControlName="amount" numeric decimals="2" onclick="click_input(this)">
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary waves-effect waves-light" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<app-concept-income-extends (onSubmitEvent)="extendsConceptIncome($event)"></app-concept-income-extends>
